"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const CheckboxCell_1 = tslib_1.__importDefault(require("./CheckboxCell"));
const EmptyCell_1 = tslib_1.__importDefault(require("./EmptyCell"));
const TextHeaderCell_1 = tslib_1.__importDefault(require("./TextHeaderCell"));
/**
 *
 * @category component
 */
const TableSimpleHeaderCell = (cell) => {
    switch (cell.kind) {
        case "text-header":
            return react_1.default.createElement(TextHeaderCell_1.default, { key: cell.columnId, ...cell });
        case "checkbox":
            return react_1.default.createElement(CheckboxCell_1.default, { key: cell.columnId, ...cell });
        case "empty":
            return react_1.default.createElement(EmptyCell_1.default, { key: cell.columnId, ...cell });
        default:
            return react_1.default.createElement(TableCell_1.default, null, "N/A");
    }
};
exports.default = TableSimpleHeaderCell;
